import React from 'react';
import ContentCategoryForm from '../../../../components/forms/ContentCategoryForm';

export default function ContentsCategoriesCreatePage() {
  return <ContentCategoryForm />;
}
